import { useEffect, useLayoutEffect } from 'react'
import { Link } from 'react-router-dom'

import { classes, HomeStyle } from './style'
import Hero from './hero'
import Typography from '@mui/material/Typography'
import UnitsCard from '../search/unitsCard'

import { getUnits, setUnits } from '../../actions/viewerActions'
import { useDispatch, useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Footer from '../../components/footer'
import ToolBar from '../../components/toolBar'
import UnitSkeleton from '../../components/UnitSkeleton'

const List = () => {
  const units = useSelector(state => state.viewer.units)
  return (
    <>
      <ToolBar/>
      <div className={classes.listContainer}>
          <Container className={classes.list}>
            <Typography align="left" variant="h5"className={classes.listTitle}>New Listings in Miami, FL</Typography>
            <Link to={'/search'} style={{ textDecoration: 'none' }}>
              <Typography align="left" color="primary">View new Listings</Typography>
              <br/>
            </Link>
            {units.length > 0 &&
              <Grid container spacing={2}>
                <UnitsCard max={3}/>
              </Grid>
            }
            {units.length === 0 &&
              <UnitSkeleton repeat={3} type="grid"/>
            }
          </Container>
      </div>
    </>
  )
}

const Home = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(setUnits([]))
  }, [])

  useLayoutEffect(() => {
    dispatch(getUnits({ max: 9, page: 1 }))
  }, [])

  return (
        <HomeStyle className={classes.root}>
            <Hero/>
            <List/>
            <Footer/>
        </HomeStyle>
  )
}

export default Home
